/**
 * Remove specific variant IDs from the Shopify cart
 * @param {Array<number>} variantIds - Array of variant IDs to remove
 * @returns {Promise<boolean>} - true if cart updated, false otherwise
 */
async function removeVariantsFromCart(variantIds = []) {
	if (!Array.isArray(variantIds) || variantIds.length === 0) return false;

	try {
		// 1. Fetch current cart
		const cart = await fetch('/cart.js').then((res) => res.json());

		let updates = {};
		let shouldUpdate = false;

		// 2. Find all line items whose variant_id matches one of the IDs
		cart.items.forEach((item) => {
			if (variantIds.includes(item.variant_id)) {
				updates[item.key] = 0; // Set quantity to 0 → removes item
				shouldUpdate = true;
			}
		});

		// 3. If nothing to remove, exit
		if (!shouldUpdate) return false;

		// 4. Send update request
		await fetch('/cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ updates }),
		});
		document.dispatchEvent(new CustomEvent('cart:updated'));

		return true;
	} catch (error) {
		console.error('Failed to remove variants:', error);
		return false;
	}
}
